var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import {} from 'react';
import classNames from 'clsx';
import { VideoContainer, VideoIframe } from './styles/video.styled';
const Video = (_a) => {
    var { className, id, title, class: reactClassName } = _a, props = __rest(_a, ["className", "id", "title", "class"]);
    const videoClassNames = classNames('PONCHO-video', className || reactClassName);
    return (_jsx(VideoContainer, Object.assign({ className: videoClassNames }, props, { children: _jsx(VideoIframe, { title: title, allowFullScreen: props.allowFullScreen || false, sandbox: "allow-scripts allow-same-origin allow-presentation", src: `https://www.youtube-nocookie.com/embed/${id}?autoplay=0&modestbranding=1&controls=1` }) })));
};
export default Video;
